import { z } from 'zod';

const SCOPE_PATTERN = /^[a-z_*-]+:[a-z_*-]+$/;

export const apiClientCreateSchema = z.object({
  name: z
    .string()
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name must be at most 100 characters'),
  clientType: z.string().min(1, 'Please select a client type'),
  isConfidential: z.boolean(),
  tenantId: z.string().uuid('Must be a valid UUID v7').optional().or(z.literal('')),
  description: z.string().max(500).optional(),
  scopes: z
    .array(z.string().regex(SCOPE_PATTERN, 'Format: action:resource (e.g. create:appointment)'))
    .min(1, 'At least one scope is required'),
  grantTypes: z.array(z.string()).min(1, 'At least one grant type is required'),
  tokenTtlSeconds: z
    .number({
      required_error: 'Token TTL is required',
      invalid_type_error: 'Token TTL must be a number',
    })
    .int('Must be a whole number')
    .positive('Must be greater than 0'),
  requiresPkce: z.boolean(),
  refreshTokenTtlSeconds: z
    .number({ invalid_type_error: 'Must be a number' })
    .int('Must be a whole number')
    .positive('Must be greater than 0')
    .optional(),
});

export type ApiClientCreateFormValues = z.infer<typeof apiClientCreateSchema>;
